module.exports = "<div *ngIf=\"notify.msg | async as msg\" class=\"notification\"\r\n  [ngClass]=\"{ \r\n    'is-danger': msg.style == 'error',\r\n    'is-success': msg.style == 'success',\r\n    'is-info': msg.style == 'info'\r\n  }\">\r\n  <button class=\"delete\" (click)=\"notify.clear()\"></button>\r\n  {{ msg.content }}\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/notification-message/notification-message.component.html
// module id = ./src/app/ui/notification-message/notification-message.component.html
// module chunks = main